import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'PALETTE',
    entityName: 'ORDER',
});

const initialState = {
    ...crudInitialState,
    deletedOrder: {},
    deleting: false,
    saving: false,
    gallery: false,
    columns: [],
    external: false
};
const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }

    // Handle other actions
    switch (action.type) {
        case 'GALLERY_OPEN_ORDER':
            return { ...state, gallery: !state.gallery };
        case 'HANDLE_DRAGGED_SET':
            return { ...state, columns: action.columns };
        case 'CLEAR_STATE':
            return { ...state, loaded: null };
        case 'EXTERNAL_ORDER':
            return { ...state, external: !state.external };
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};

export default reducer;
